export default {
  title: 'Winkelwagen',
};
